"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ferentillo": {
    "bb192ff3": [{
      "hkey": "e6f53328",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "capoluogo-matterella": [{
      "hkey": "e6f53328",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5ac267a6": [{
      "hkey": "91d94b32",
      "slug": "colle-olivo",
      "name": "Colle Olivo",
      "primary": true,
      "skipSearch": false
    }],
    "colleolivo": [{
      "hkey": "91d94b32",
      "slug": "colle-olivo",
      "name": "Colle Olivo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "180b98a5": [{
      "hkey": "2eb71890",
      "slug": "ferentillo",
      "name": "Ferentillo",
      "primary": true,
      "skipSearch": false
    }],
    "colli": [{
      "hkey": "2eb71890",
      "slug": "ferentillo",
      "name": "Ferentillo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "009205ab": [{
      "hkey": "2eb71890",
      "slug": "ferentillo",
      "name": "Ferentillo",
      "primary": true,
      "skipSearch": false
    }],
    "gabbio": [{
      "hkey": "2eb71890",
      "slug": "ferentillo",
      "name": "Ferentillo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "acdb5ad0": [{
      "hkey": "2eb71890",
      "slug": "ferentillo",
      "name": "Ferentillo",
      "primary": true,
      "skipSearch": false
    }],
    "macelletto": [{
      "hkey": "2eb71890",
      "slug": "ferentillo",
      "name": "Ferentillo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dff3ac34": [{
      "hkey": "e6f53328",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "precetto": [{
      "hkey": "e6f53328",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferentillo"
    }],
    "c1242400": [{
      "hkey": "2eb71890",
      "slug": "ferentillo",
      "name": "Ferentillo",
      "primary": true,
      "skipSearch": false
    }],
    "umbriano": [{
      "hkey": "2eb71890",
      "slug": "ferentillo",
      "name": "Ferentillo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a699ecd0": [{
      "hkey": "2eb71890",
      "slug": "ferentillo",
      "name": "Ferentillo",
      "primary": true,
      "skipSearch": false
    }],
    "volparo": [{
      "hkey": "2eb71890",
      "slug": "ferentillo",
      "name": "Ferentillo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;